import { TTableHeadType } from "./generic-type";

export enum ViewPortSizeVariationEnum {
  XS = "Extra Small (XS)",
  SM = "Small (SM)",
  MD = "Medium (MD)",
  LG = "Large (LG)",
  UK = "Unknown"
}

export type TViewPortRankingCard = {
  order: number;
  iconTitle: string;
  title: string;
  text: string;
  subText: string;
  outcomes: string;
  recommendation: string;
};

export type TViewPortRankingResponse = {
  range: string;
  cards: TViewPortRankingCard[];
  viewportRankingTable: {
    screenResolution: string;
    nVisitors: number;
    percentageVisitors: string;
    nConversions: number;
    percentageConversions: string;
    nBounces: number;
    percentageBounces: string;
  }[];
};

type TViewPortRankingTableBody = {
  viewPortSize: ViewPortSizeVariationEnum;
  converted: string;
  visitors: string;
  bounced: string;
};

export type TViewPortRanking = {
  range: string;
  cards: TViewPortRankingCard[];
  viewPortRanking: {
    dataColumns: TTableHeadType[];
    dataRows: TViewPortRankingTableBody[];
  };
};
